import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSongsMobileFilterGroupFeaturesLogic} from "./SongsMobileFilterGroupFeatures.logic";
import {DisclosureGroup} from "../../../../../../components/common/disclosure-group/DisclosureGroup";
import {FilterFeatures} from "../../../../../../modules/songs/filter-features/FilterFeatures";

export const SongsMobileFilterGroupFeatures: VoidFunctionComponent = () => {
  const {filterLabel} = useSongsMobileFilterGroupFeaturesLogic();
  return (
    <DisclosureGroup title={"Types"} secondaryInfo={filterLabel}>
      <FilterFeatures />
    </DisclosureGroup>
  );
}
